module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO7_06 (13).ff9b390.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO7_06 (13).mp4
// module id = 788
// module chunks = 1